import React,{useEffect,useState} from "react";
import "./Reimbursement.css";
import API from "../services/api";
import {useNavigate} from "react-router-dom";
export default function UserReimbursement(){


const [billFile,setBillFile]=useState(null);
const [loadingBill, setLoadingBill]=useState(false);
const [employeeName,setEmployeeName]=useState("");

const [title,setTitle]=useState("");

const [employer,setEmployer]=useState("");
const navigate=useNavigate();
/* ================= EXPENSE ROWS ================= */

const [expenseRows,setExpenseRows]=
useState([
{
id:1,
date:"",
paymentMethod:"",
purpose:"",
},
]);

/* ================= SUMMARY ROWS ================= */

const [summaryRows,setSummaryRows]=
useState([
{
id:1,
description:"",
airRail:"",
groundTrans:"",
lodging:"",
meals:"",
other:"",
total:0,
},
]);

/* ================= USER ================= */

useEffect(()=>{

const user=
localStorage.getItem("username");

if(user){

setEmployeeName(user);

}

},[]);

/* ================= EXPENSE INPUT ================= */

const handleExpenseChange=(
index,
field,
value
)=>{

const updated=[...expenseRows];

updated[index][field]=value;

setExpenseRows(updated);

};

/* ================= BILL OCR ================= */

const handleBillUpload=async(e)=>{

const file=e.target.files[0];

if(!file) return;

setBillFile(file);

const formData=new FormData();

formData.append("bill",file);

try{

setLoadingBill(true);

const res=await API.post(
"/reimbursement/extract-bill",
formData,
{
headers:{
"Content-Type":
"multipart/form-data"
}
}
);

const data=res.data;

/* Auto Fill Expense Table */
setExpenseRows([
{
id:Date.now(),
date:data.date || "",
paymentMethod:data.paymentMethod || "",
purpose:
data.purpose ||
data.vendor ||
"",
billAmount:data.amount || 0
}
]);

/* Auto Fill Summary Table */
const amount=
Number(data.amount)||0;

const summaryRow={
id:Date.now(),
description:data.purpose || "",
airRail:"",
groundTrans:"",
lodging:"",
meals:"",
other:"",
total:amount
};

if(data.category==="Air/Rail"){

summaryRow.airRail=amount;

}
else if(data.category==="Ground"){

summaryRow.groundTrans=amount;

}
else if(data.category==="Lodging"){

summaryRow.lodging=amount;

}
else if(data.category==="Meals"){

summaryRow.meals=amount;

}
else{

summaryRow.other=amount;

}

setSummaryRows([summaryRow]);
alert(
"Bill Processed Successfully"
);

}catch(err){

console.log(err);

alert(
"Unable To Read Bill"
);

}
finally{

setLoadingBill(false);

}

};


/* ================= SUMMARY INPUT ================= */

const handleSummaryChange=(
index,
field,
value
)=>{

const updated=[...summaryRows];

updated[index][field]=value;

const row=updated[index];

const total=
(Number(row.airRail)||0)+
(Number(row.groundTrans)||0)+
(Number(row.lodging)||0)+
(Number(row.meals)||0)+
(Number(row.other)||0);

row.total=total;

setSummaryRows(updated);

};

/* ================= ADD EXPENSE ROW ================= */

const addExpenseRow=()=>{

setExpenseRows([
...expenseRows,
{
id:Date.now(),
date:"",
paymentMethod:"",
purpose:"",
},
]);

};

/* ================= ADD SUMMARY ROW ================= */

const addSummaryRow=()=>{

setSummaryRows([
...summaryRows,
{
id:Date.now(),
description:"",
airRail:"",
groundTrans:"",
lodging:"",
meals:"",
other:"",
total:0,
},
]);

};

/* ================= DELETE EXPENSE ================= */

const deleteExpenseRow=(index)=>{

const updated=[...expenseRows];

updated.splice(index,1);

setExpenseRows(updated);

};

/* ================= DELETE SUMMARY ================= */

const deleteSummaryRow=(index)=>{

const updated=[...summaryRows];

updated.splice(index,1);

setSummaryRows(updated);

};

/* ================= SAVE ================= */

const saveExpenseRow=(row)=>{

console.log("Saved Expense:",row);

alert("Expense Saved");

};

const saveSummaryRow=(row)=>{

console.log("Saved Summary:",row);

alert("Summary Saved");

};

/* ================= GRAND TOTAL ================= */

const grandTotal=
summaryRows.reduce(
(sum,row)=>sum+row.total,
0
);

/* ================= SUBMIT ================= */

const handleSubmit=async()=>{

try{

const res=
await API.post(
"/reimbursement",
{

employeeName,

title,

employer,

expenseRows,

summaryRows,

grandTotal

}
);

console.log(res.data);

alert(
"Reimbursement Submitted Successfully"
);

setTitle("");

setEmployer("");

setExpenseRows([
{
id:1,
date:"",
paymentMethod:"",
purpose:"",
},
]);

setSummaryRows([
{
id:1,
description:"",
airRail:"",
groundTrans:"",
lodging:"",
meals:"",
other:"",
total:0,
},
]);

}catch(err){

console.log(err);

alert("Submission Failed");

}

};

return(

<div className="reimbursement-container">

<div className="paper">

<h1 className="main-title">
Employee Reimbursement Form
</h1>

{/* ================= TOP DETAILS ================= */}

<div className="top-details">

<div className="detail-row">

<label>
Name:
</label>

<input
type="text"
value={employeeName}
readOnly
/>

</div>

<div className="detail-row">

<label>
Title:
</label>

<input
type="text"
value={title}
onChange={(e)=>
setTitle(e.target.value)
}
/>

</div>

<div className="detail-row">

<label>
Employer:
</label>

<input
type="text"
value={employer}
onChange={(e)=>
setEmployer(e.target.value)
}
/>

</div>

</div>

{/* ================= BILL ATTACHMENT ================= */}

<div
style={{
display:"flex",
justifyContent:"space-between",
alignItems:"center",
marginBottom:"20px"
}}	
>

<div>

<label
className="attach-btn"
>

📎 Attach Bill

<input
type="file"
accept="image/*,.pdf"
hidden
onChange={handleBillUpload}
/>

</label>

{billFile && (

<span
style={{
marginLeft:"10px",
fontWeight:"bold"
}}
>
{billFile.name}
</span>

)}

</div>

{loadingBill && (

<div
style={{
fontWeight:"bold",
color:"green"
}}
>

Processing Bill...

</div>

)}

</div>


{/* ================= EXPENSE TABLE ================= */}

<table className="expense-table">

<thead>

<tr>

<th>#</th>

<th>
Dates of Expense(s)
</th>

<th>
Payment Method
</th>

<th>
Purpose of Expenditure(s)
</th>

<th>
Action
</th>

</tr>

</thead>

<tbody>

{expenseRows.map(
(row,index)=>(

<tr key={row.id}>

<td>
#{index+1}
</td>

<td>

<input
type="date"
value={row.date}
onChange={(e)=>
handleExpenseChange(
index,
"date",
e.target.value
)
}
/>

</td>

<td>

<input
type="text"
placeholder="Cash / UPI"
value={row.paymentMethod}
onChange={(e)=>
handleExpenseChange(
index,
"paymentMethod",
e.target.value
)
}
/>

</td>

<td>

<input
type="text"
placeholder="Purpose"
value={row.purpose}
onChange={(e)=>
handleExpenseChange(
index,
"purpose",
e.target.value
)
}
/>

</td>

<td>

<button
className="save-btn"
onClick={()=>
saveExpenseRow(row)
}
>
Save
</button>

<button
className="add-btn"
onClick={addExpenseRow}
>
Add
</button>

<button
className="delete-btn"
onClick={()=>
deleteExpenseRow(index)
}
>
Delete
</button>

</td>

</tr>

)
)}

</tbody>

</table>

{/* ================= SUMMARY ================= */}

<h2 className="summary-title">
Summary of Expenses
</h2>

<table className="summary-table">

<thead>

<tr>

<th>#</th>

<th>
Description
</th>

<th>
Air/Rail Travel
</th>

<th>
Ground Trans
</th>

<th>
Lodging
</th>

<th>
Meals
</th>

<th>
Other
</th>

<th>
Total
</th>

<th>
Action
</th>

</tr>

</thead>

<tbody>

{summaryRows.map(
(row,index)=>(

<tr key={row.id}>

<td>
#{index+1}
</td>

<td>

<input
type="text"
value={row.description}
onChange={(e)=>
handleSummaryChange(
index,
"description",
e.target.value
)
}
/>

</td>

<td>

<input
type="text"
value={row.airRail}
onChange={(e)=>
handleSummaryChange(
index,
"airRail",
e.target.value
)
}
/>

</td>

<td>

<input
type="text"
value={row.groundTrans}
onChange={(e)=>
handleSummaryChange(
index,
"groundTrans",
e.target.value
)
}
/>

</td>

<td>

<input
type="text"
value={row.lodging}
onChange={(e)=>
handleSummaryChange(
index,
"lodging",
e.target.value
)
}
/>

</td>

<td>

<input
type="text"
value={row.meals}
onChange={(e)=>
handleSummaryChange(
index,
"meals",
e.target.value
)
}
/>

</td>

<td>

<input
type="text"
value={row.other}
onChange={(e)=>
handleSummaryChange(
index,
"other",
e.target.value
)
}
/>

</td>

<td>
₹ {row.total}
</td>

<td>

<button
className="save-btn"
onClick={()=>
saveSummaryRow(row)
}
>
Save
</button>

<button
className="add-btn"
onClick={addSummaryRow}
>
Add
</button>

<button
className="delete-btn"
onClick={()=>
deleteSummaryRow(index)
}
>
Delete
</button>

</td>

</tr>

)
)}

<tr className="grand-total-row">

<td
colSpan="7"
className="grand-label"
>
Expense Report Total
</td>

<td>
₹ {grandTotal}
</td>

<td></td>

</tr>

</tbody>

</table>

 <div

style={{
display:"flex",
justifyContent:"flex-end",
marginTop:"10px"
}}
>

<button
className="submit-btn"
onClick={handleSubmit}
>

Submit Reimbursement

</button>
</div>

</div>
<div
style={{
display:"flex",
justifyContent:"flex-end",
marginTop:"10px"
}}
>

<button
className="submitted-btn"
onClick={()=>
navigate("/submittedforms")
}
>

Submitted Forms

</button>

</div>

</div>

);

}